import React from 'react';
import TableHead from '@material-ui/core/TableHead';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Table, TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  table: {
    tableLayout: 'fixed',
  },
  headerCell: {
    fontWeight: 'bold',
    paddingRight: theme.spacing(4),
  },
  tableCell: {
    padding: theme.spacing(2),
  },
}));

const ListHeader = () => {
  const classes = useStyles();
  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.headerCell}>نام</TableCell>
          <TableCell className={classes.headerCell}>وضعیت</TableCell>
          <TableCell className={classes.headerCell}>شماره تماس</TableCell>
          <TableCell className={classes.headerCell}>مبلغ</TableCell>
          <TableCell className={classes.headerCell}>تاریخ</TableCell>
          <TableCell className={classes.headerCell}></TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );
};

export default ListHeader;
